// @core/api/endpoints/affiliate/reject_conversion.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ConversionResponse,
  RejectConversionRequest,
} from '../../../types/affiliate';

const BASE_PATH = '/affiliate';

/**
 * Reject conversion
 * Performs reject operation on conversion.
 */
export async function RejectConversion(
  conversion_id: string,
  data: RejectConversionRequest,
  options?: RequestOptions
): Promise<ConversionResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/conversions/:conversion_id/reject`;
  requestPath = requestPath.replace(':conversion_id', encodeURIComponent(conversion_id));
  const requestOptions = options;
  return client.post<ConversionResponse>(requestPath, data, requestOptions);
}
